import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ToastError from "../../components/Notification/ToastError";
import ProfilePage from "../../components/Profile/index";
import { authsignature, headers, storage } from "../../libs";
import { ValPassword, ValProfile } from "../../validation/ProfileValidation";

const initialData = {
  first_name: "",
  last_name: "",
  no_hp: 0,
  alamat: "",
  provinsi: "",
  kota: "",
  kecamatan: "",
  kelurahan: "",
  kodepos: "",
  gender: 1,
  tempat_lahir: "",
  tgl_lahir: "",
};

const initialPassword = {
  password_lama: "",
  password_baru: "",
  c_password_baru: "",
};

function Profile() {
  const history = useHistory();
  const location = useLocation();
  const [isPersonal, setPersonal] = useState(1); // 1. Data Diri, 0. Address
  const [isProfile, setProfile] = useState(1); //1. Profile, 0. Setting, 2. Riwayat Transaksi
  const [data, setData] = useState(null);
  const [update, setUpdate] = useState(initialData);

  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState([]);

  const [province, setProvince] = useState([]);
  const [city, setCity] = useState([]);
  const [district, setDistrict] = useState([]);
  const [area, setArea] = useState([]);

  const [password, setPassword] = useState(initialPassword);
  const [isView, setView] = useState(false);
  const [isCheck, setCheck] = useState(false);

  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const onError = () => {
    setOpen(false);
  };

  /**  HISTORY SECTION FUNCTIONAL */

  const limit = 5;
  const [isHistory, setHistory] = useState([]);
  const [total, setTotal] = useState("0");
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [loadMore, setLoadMore] = useState(false);
  const [isMenu, setMenu] = useState(1);
  const [page, setPage] = useState("0");

  // ----------------------------->

  useEffect(() => {
    if (location) {
      if (location.pathname === "/profile/setting") {
        setProfile(0);
      } else if (location.pathname === "/profile/history") {
        setProfile(2);
      }
    }
  }, [location]);

  /** Get Data User */
  const GetData = async () => {
    try {
      const auth = await storage();

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/profile/detail`,
        { email: auth.xtoken },
        { headers: await authsignature(auth.token, { email: auth.xtoken }) }
      );

      if (Number(response.data.code) === 200) {
        setData({ ...response.data.data, email: auth.xtoken });
        setUpdate({
          ...update,
          first_name: response?.data?.data?.first_name ?? "",
          last_name: response?.data?.data?.last_name ?? "",
          no_hp: response.data.data.telp,
          alamat: response?.data?.data?.alamat ?? "",
          provinsi: response?.data?.data?.provinsi ?? "",
          kota: response?.data?.data?.kota ?? "",
          kecamatan: response?.data?.data?.kecamatan ?? "",
          kelurahan: response?.data?.data?.kelurahan ?? "",
          kodepos: response?.data?.data?.kodepos ?? "",
          gender: response?.data?.data?.gender ?? 1,
          tempat_lahir: response?.data?.data?.tempat_lahir ?? "",
          tgl_lahir: response?.data?.data?.tgl_lahir ?? "",
        });
        await GetAddress({
          provinsi: response.data.data.provinsi,
          kota: response.data.data.kota,
          kecamatan: response.data.data.kecamatan,
          kelurahan: response.data.data.kelurahan,
        });
      } else {
        setOpen(true);
        setResponse("");
      }
    } catch (e) {
      setOpen(true);
      setResponse("");
    }
  };

  /** Get Data Address */
  const GetAddress = async (value) => {
    /** Get Provinsi */
    try {
      const provinsi = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/wilayah`,
        {},
        { headers: await headers({}) }
      );

      if (provinsi.data.data.length > 0) {
        setProvince(provinsi.data.data);
      } else {
        setOpen(true);
        setResponse("");
      }
    } catch (e) {
      setOpen(true);
      setResponse("");
    }

    /** Get Kota */
    if (value.provinsi) {
      try {
        const kota = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/wilayah`,
          { propinsi: value.provinsi },
          { headers: await headers({ propinsi: value.provinsi }) }
        );

        if (kota.data.data.length > 0) {
          setCity(kota.data.data);
        } else {
          setOpen(true);
          setResponse("");
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
      }
    }

    /** Get Kecamatan */
    if (value.kota) {
      try {
        const kecamatan = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/wilayah`,
          { propinsi: value.provinsi, kota: value.kota },
          {
            headers: await headers({
              propinsi: value.provinsi,
              kota: value.kota,
            }),
          }
        );

        if (kecamatan.data.data.length > 0) {
          setDistrict(kecamatan.data.data);
        } else {
          setOpen(true);
          setResponse("");
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
      }
    }

    /** Get Kelurahan */
    if (value.kecamatan) {
      try {
        const kelurahan = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/wilayah`,
          {
            propinsi: value.provinsi,
            kota: value.kota,
            kecamatan: value.kecamatan,
          },
          {
            headers: await headers({
              propinsi: value.provinsi,
              kota: value.kota,
              kecamatan: value.kecamatan,
            }),
          }
        );

        if (kelurahan.data.data.length > 0) {
          setArea(kelurahan.data.data);
        } else {
          setOpen(true);
          setResponse("");
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
      }
    }
  };

  /** Get Data to State */
  useEffect(() => {
    GetData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** Handle Pilih Data Diri atau Address */
  const onMove = async () => {
    if (isPersonal === 1) {
      setPersonal(0);
      /** Jika ingin mempertahankan state pindah tab hapus get data dan set error */
      await GetData();
      setError([]);
    } else {
      setPersonal(1);
      await GetData();
      setError([]);
    }
  };

  /** Handle Pilih Profile atau Pengaturan Password */
  const onProfile = (value) => {
    setProfile(value);
    if (value === 1) {
      history.push("/profile");
    } else if (value === 0) {
      history.push("/profile/setting");
    } else {
      history.push("/profile/history");
    }
  };

  /** Handle Perubahan State di Input */
  const onChange = (e) => {
    //Data Diri

    const { name, value } = e.target;
    if (name === "no_hp") {
      setUpdate({ ...update, [name]: value.replace(/[^0-9]/g, "") });
    } else {
      setUpdate({ ...update, [name]: value });
    }
    setError([]);
  };

  /** Handle Select Address */

  const onSelect = async (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setError([]);
    if (name === "provinsi") {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/wilayah`,
          { propinsi: value },
          { headers: await headers({ propinsi: value }) }
        );

        if (response.data.data.length > 0) {
          setCity(response.data.data);
          setDistrict([]);
          setArea([]);
          setUpdate({
            ...update,
            provinsi: value,
            kota: null,
            kecamatan: null,
            kelurahan: null,
            kodepos: null,
          });
        } else {
          setOpen(true);
          setResponse("");
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
      }
    } else if (name === "kota") {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/wilayah`,
          { propinsi: update.provinsi, kota: value },
          {
            headers: await headers({ propinsi: update.provinsi, kota: value }),
          }
        );

        if (response.data.data.length > 0) {
          setDistrict(response.data.data);
          setArea([]);
          setUpdate({
            ...update,
            kota: value,
            kecamatan: null,
            kelurahan: null,
            kodepos: null,
          });
        } else {
          setOpen(true);
          setResponse("");
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
      }
    } else if (name === "kecamatan") {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/wilayah`,
          { propinsi: update.provinsi, kota: update.kota, kecamatan: value },
          {
            headers: await headers({
              propinsi: update.provinsi,
              kota: update.kota,
              kecamatan: value,
            }),
          }
        );

        if (response.data.data.length > 0) {
          setArea(response.data.data);

          setUpdate({
            ...update,
            kecamatan: value,
            kelurahan: null,
            kodepos: null,
          });
        } else {
          setOpen(true);
          setResponse("");
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
      }
    } else if (name === "kelurahan") {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/wilayah`,
          {
            propinsi: update.provinsi,
            kota: update.kota,
            kecamatan: update.kecamatan,
            kelurahan: value,
          },
          {
            headers: await headers({
              propinsi: update.provinsi,
              kota: update.kota,
              kecamatan: update.kecamatan,
              kelurahan: value,
            }),
          }
        );

        if (response.data.data.length > 0) {
          setUpdate({
            ...update,
            kelurahan: value,
            kodepos: response.data.data[0].kodepos,
          });
        } else {
          setOpen(true);
          setResponse("");
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
      }
    }
  };

  /** Handle Gender */

  const onGender = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setUpdate({ ...update, [name]: value });
  };

  /** Handle Button Save Profile */
  const onSubmit = async () => {
    setLoading(true);
    const auth = await storage();
    const error = await ValProfile(update, isPersonal);

    if (isPersonal === 1) {
      delete update.alamat;
      delete update.provinsi;
      delete update.kecamatan;
      delete update.kelurahan;
      delete update.kodepos;
      delete update.kota;
    }

    if (error.length > 0) {
      setError(error);
      setLoading(false);
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/profile/update`,
          { ...update },
          { headers: await authsignature(auth.token, { ...update }) }
        );
        if (Number(response.data.code) === 200) {
          // toastSuccess(response.data.message);
          setLoading(false);
        } else {
          setOpen(true);
          setResponse("");
          setLoading(false);
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
        setLoading(false);
      }
    }
  };

  /** Start dari Pengaturan */
  const onView = () => {
    if (isView) {
      setView(false);
    } else {
      setView(true);
    }
  };

  const onChangePassword = (e) => {
    const { name, value } = e.target;
    setError([]);

    if (name === "password_lama") {
      setPassword({
        ...password,
        password_lama: value,
        password_baru: "",
        c_password_baru: "",
      });
      setCheck(false);
    } else {
      setPassword({ ...password, [name]: value });
    }
  };

  const onChecking = async () => {
    setLoading(true);
    const error = await ValPassword(password, true);
    const auth = await storage();

    if (error.length > 0) {
      setError(error);
      setLoading(false);
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/profile/inquiry/password`,
          { password_lama: password.password_lama },
          {
            headers: await authsignature(auth.token, {
              password_lama: password.password_lama,
            }),
          }
        );

        if (Number(response.data.code) === 200) {
          setCheck(true);
          // toastSuccess(response.data.message);
        } else {
          setCheck(false);
          setOpen(true);
          setResponse(response.data.message);
        }
        setLoading(false);
      } catch (e) {
        setOpen(true);
        setResponse("");
        setLoading(false);
      }
    }
  };

  const onSubmitPassword = async () => {
    setLoading(true);
    const error = await ValPassword(password, false);
    const auth = await storage();

    if (error.length > 0) {
      setError(error);
      setLoading(false);
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/profile/update/password`,
          { ...password },
          { headers: await authsignature(auth.token, { ...password }) }
        );

        if (Number(response.data.code) === 200) {
          // toastSuccess(response.data.message);
          setPassword(initialPassword);
          setCheck(false);
          history.push("/profile/n/password");
        } else {
          setOpen(true);
          setResponse(response.data.message);
        }
        setLoading(false);
      } catch (e) {
        setOpen(true);
        setResponse("");
        setLoading(false);
      }
    }
  };

  /**  HISTORY SECTION FUNCTIONAL */
  const GetDataHistory = async () => {
    setLoadingHistory(true);
    try {
      const auth = await storage();

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/transaction/history`,
        { offset: page, limit },
        { headers: await authsignature(auth.token, { offset: page, limit }) }
      );

      if (Number(response.data.code) === 200) {
        if (response.data.message !== "Data tidak ditemukan") {
          setHistory(response.data.data.history_transaksi);
          setTotal(response.data.data.summary_pesanan);
          setLoadingHistory(false);
        } else {
          setLoadingHistory(false);
          setHistory([]);
        }
      } else {
        setHistory([]);
      }
    } catch (e) {
      setHistory([]);

      setOpen(true);
      setResponse("");
      setLoadingHistory(false);
    }
  };

  useEffect(() => {
    GetDataHistory();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** Select Menu di History */
  const onFilter = async (type, e) => {
    // type 1. Dekstop, 2. Mobile
    if (type === 1) {
      setMenu(e);
      await dataMenu(e);
    } else {
      const value = e.target.value;
      setMenu(value);
      await dataMenu(value);
    }
  };

  const dataMenu = async (menu) => {
    setPage("0");
    // menu : 1. Semua, 2 Layanan Kesehatan, 3. Media Reagensia

    if (Number(menu) === 1) {
      setLoadingHistory(true);
      try {
        const auth = await storage();

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/transaction/history`,
          { offset: "0", limit },
          { headers: await authsignature(auth.token, { offset: "0", limit }) }
        );

        if (Number(response.data.code) === 200) {
          setHistory(response.data.data.history_transaksi);
          setTotal(response.data.data.summary_pesanan);
          setLoadingHistory(false);
        } else {
          setHistory([]);

          setOpen(true);
          setResponse("");
          setLoadingHistory(false);
        }
      } catch (e) {
        setHistory([]);

        setOpen(true);
        setResponse("");
        setLoadingHistory(false);
      }
    } else if (Number(menu) === 2) {
      setLoadingHistory(true);
      try {
        const auth = await storage();

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/transaction/history`,
          { offset: "0", limit, filter: "1" },
          {
            headers: await authsignature(auth.token, {
              offset: "0",
              limit,
              filter: "1",
            }),
          }
        );

        if (Number(response.data.code) === 200) {
          setHistory(response.data.data.history_transaksi);
          setTotal(response.data.data.summary_pesanan);
          setLoadingHistory(false);
        } else {
          setHistory([]);

          setOpen(true);
          setResponse("");
          setLoadingHistory(false);
        }
      } catch (e) {
        setHistory([]);

        setOpen(true);
        setResponse("");
        setLoadingHistory(false);
      }
    } else if (Number(menu) === 3) {
      setLoadingHistory(true);
      try {
        const auth = await storage();

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/transaction/history`,
          { offset: "0", limit, filter: "2" },
          {
            headers: await authsignature(auth.token, {
              offset: "0",
              limit,
              filter: "2",
            }),
          }
        );

        if (Number(response.data.code) === 200) {
          setHistory(response.data.data.history_transaksi);
          setTotal(response.data.data.summary_pesanan);
          setLoadingHistory(false);
        } else {
          setHistory([]);

          setOpen(true);
          setResponse("");
          setLoadingHistory(false);
        }
      } catch (e) {
        setHistory([]);

        setOpen(true);
        setResponse("");
        setLoadingHistory(false);
      }
    }
  };

  const onPagination = async () => {
    setLoadMore(true);

    if (isMenu === 1) {
      try {
        const auth = await storage();
        const pages = 5 + Number(page);
        setPage(pages.toString());

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/transaction/history`,
          { offset: pages.toString(), limit },
          {
            headers: await authsignature(auth.token, {
              offset: pages.toString(),
              limit,
            }),
          }
        );

        if (Number(response.data.code) === 200) {
          if (response.data.hasOwnProperty("data")) {
            let data = [...isHistory];
            data.push(response.data.data.history_transaksi);
            data = data.flat();

            setHistory(data);
          }
        } else {
          setOpen(true);
          setResponse("");
        }

        setLoadMore(false);
      } catch (e) {
        setLoadMore(false);

        setOpen(true);
        setResponse("");
      }
    } else if (isMenu === 2) {
      try {
        const auth = await storage();
        const pages = 5 + Number(page);
        setPage(pages.toString());

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/transaction/history`,
          { offset: pages.toString(), limit, filter: "1" },
          {
            headers: await authsignature(auth.token, {
              offset: pages.toString(),
              limit,
              filter: "1",
            }),
          }
        );

        if (Number(response.data.code) === 200) {
          if (response.data.hasOwnProperty("data")) {
            let data = [...isHistory];
            data.push(response.data.data.history_transaksi);
            data = data.flat();

            setHistory(data);
          }
        } else {
          setOpen(true);
          setResponse("");
        }

        setLoadMore(false);
      } catch (e) {
        setLoadMore(false);

        setOpen(true);
        setResponse("");
      }
    } else if (isMenu === 3) {
      try {
        const auth = await storage();
        const pages = 5 + Number(page);
        setPage(pages.toString());

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/transaction/history`,
          { offset: pages.toString(), limit, filter: "2" },
          {
            headers: await authsignature(auth.token, {
              offset: pages.toString(),
              limit,
              filter: "2",
            }),
          }
        );

        if (Number(response.data.code) === 200) {
          if (response.data.hasOwnProperty("data")) {
            let data = [...isHistory];
            data.push(response.data.data.history_transaksi);
            data = data.flat();

            setHistory(data);
          }
        } else {
          setOpen(true);
          setResponse("");
        }

        setLoadMore(false);
      } catch (e) {
        setLoadMore(false);

        setOpen(true);
        setResponse("");
      }
    }
  };

  return (
    <>
      <ToastError props={{ open, response, onError }} />
      <ProfilePage
        props={{
          isPersonal,
          onMove,
          isProfile,
          onProfile,
          data,
          update,
          onChange,
          onSubmit,
          province,
          onSelect,
          city,
          district,
          area,
          isError,
          loading,
          onChangePassword,
          onChecking,
          isCheck,
          onView,
          isView,
          onSubmitPassword,
          password,
          isHistory,
          loadingHistory,
          onFilter,
          isMenu,
          onPagination,
          total,
          loadMore,
          onGender,
        }}
      />
    </>
  );
}

export default Profile;
